module.exports = __webpack_public_path__ + "static/media/the-branch.adf7238c.jpg";